import { IRouteState } from './../../../../../app.common/modules/routes/models';
import * as angular from 'angular';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { StateService } from '@uirouter/core';
import { EnumListItem } from '../../../core/index';
import { ProductsService } from '../../../products/products.service';


class HelpCountriesController implements ng.IComponentController {
    static $inject = ['productsService', 'notificationService', '$state', '$translate', '$location'];

    waiting: boolean;
    items: EnumListItem[];
    isNotPublicRoute: boolean;

    constructor(
        private readonly productsService: ProductsService,
        private readonly notificationServcie: NotificationService,
        private readonly $state: StateService,
        private readonly $translate: angular.translate.ITranslateService,
        private readonly $location: ng.ILocationService,
    ) {
    }

    goToProductsImport() {
        this.$state.go('app.operations');
    }

    goToHelp() {
        this.$state.go('app.help.manual');
    }

    async $onInit() {
        this.isNotPublicRoute = this.$location.path() !== '/help/dictionary';
        this.waiting = true;

        try {
            this.items = await this.productsService.GetCountryOrigins();

        } catch (e) {
            this.notificationServcie.showErrorMessage(e);
        }

        this.waiting = false;
    }
}

angular
    .module('naut')
    .component('helpCountries', {
        controller: HelpCountriesController,
        template: require('./help-countries.component.html')
    });



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/inventory/components/help-countries/help-countries.component.ts